/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiIsReScreeningEnabledEvent } from './InternalApiIsReScreeningEnabledEvent';
import {
    InternalApiIsReScreeningEnabledEventFromJSON,
    InternalApiIsReScreeningEnabledEventFromJSONTyped,
    InternalApiIsReScreeningEnabledEventToJSON,
    InternalApiIsReScreeningEnabledEventToJSONTyped,
} from './InternalApiIsReScreeningEnabledEvent';
import type { InternalApiDocumentEvent } from './InternalApiDocumentEvent';
import {
    InternalApiDocumentEventFromJSON,
    InternalApiDocumentEventFromJSONTyped,
    InternalApiDocumentEventToJSON,
    InternalApiDocumentEventToJSONTyped,
} from './InternalApiDocumentEvent';

/**
 * Comprises of different events of an alert
 * @export
 * @interface InternalApiAlertEvents
 */
export interface InternalApiAlertEvents {
    /**
     * 
     * @type {Array<InternalApiIsReScreeningEnabledEvent>}
     * @memberof InternalApiAlertEvents
     */
    isReScreeningEnabledEvents: Array<InternalApiIsReScreeningEnabledEvent>;
    /**
     * 
     * @type {Array<InternalApiDocumentEvent>}
     * @memberof InternalApiAlertEvents
     */
    documentEvents?: Array<InternalApiDocumentEvent>;
}

/**
 * Check if a given object implements the InternalApiAlertEvents interface.
 */
export function instanceOfInternalApiAlertEvents(value: object): value is InternalApiAlertEvents {
    if (!('isReScreeningEnabledEvents' in value) || value['isReScreeningEnabledEvents'] === undefined) return false;
    return true;
}

export function InternalApiAlertEventsFromJSON(json: any): InternalApiAlertEvents {
    return InternalApiAlertEventsFromJSONTyped(json, false);
}

export function InternalApiAlertEventsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertEvents {
    if (json == null) {
        return json;
    }
    return {
        
        'isReScreeningEnabledEvents': ((json['isReScreeningEnabledEvents'] as Array<any>).map(InternalApiIsReScreeningEnabledEventFromJSON)),
        'documentEvents': json['documentEvents'] == null ? undefined : ((json['documentEvents'] as Array<any>).map(InternalApiDocumentEventFromJSON)),
    };
}

export function InternalApiAlertEventsToJSON(json: any): InternalApiAlertEvents {
    return InternalApiAlertEventsToJSONTyped(json, false);
}

export function InternalApiAlertEventsToJSONTyped(value?: InternalApiAlertEvents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isReScreeningEnabledEvents': ((value['isReScreeningEnabledEvents'] as Array<any>).map(InternalApiIsReScreeningEnabledEventToJSON)),
        'documentEvents': value['documentEvents'] == null ? undefined : ((value['documentEvents'] as Array<any>).map(InternalApiDocumentEventToJSON)),
    };
}

